import { jsx, jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import {
  Button,
  Card,
  Elevation,
  FormGroup,
  InputGroup,
  Intent,
  H3
} from "@blueprintjs/core";
import axios from "axios";
const LoginPage = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const response = await axios.post("/api/login", {
        email,
        password
      });
      const { token, company_id, role, user } = response.data;
      localStorage.setItem("ove_token", token);
      if (company_id) {
        localStorage.setItem("ove_company_id", company_id);
        axios.defaults.headers.common["X-Company-Id"] = company_id;
      }
      if (role) {
        localStorage.setItem("ove_user_role", role);
      }
      if (user?.email || email) {
        localStorage.setItem("ove_user_email", user?.email || email);
      }
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      onLogin();
    } catch (err) {
      setError(err.response?.data?.error || "Login failed. Please check your credentials.");
    } finally {
      setLoading(false);
    }
  };
  return /* @__PURE__ */ jsx("div", { style: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#f5f8fa"
  }, children: /* @__PURE__ */ jsxs(Card, { elevation: Elevation.TWO, style: { width: "400px" }, children: [
    /* @__PURE__ */ jsx("div", { style: { textAlign: "center", marginBottom: "20px" }, children: /* @__PURE__ */ jsx(H3, { children: "Vector Editor Login" }) }),
    /* @__PURE__ */ jsxs("form", { onSubmit: handleSubmit, children: [
      /* @__PURE__ */ jsx(
        FormGroup,
        {
          label: "Email Address",
          labelFor: "email-input",
          children: /* @__PURE__ */ jsx(
            InputGroup,
            {
              id: "email-input",
              placeholder: "user@delvetx.com",
              value: email,
              onChange: (e) => setEmail(e.target.value),
              required: true
            }
          )
        }
      ),
      /* @__PURE__ */ jsx(
        FormGroup,
        {
          label: "Password",
          labelFor: "password-input",
          children: /* @__PURE__ */ jsx(
            InputGroup,
            {
              id: "password-input",
              type: "password",
              placeholder: "Enter password",
              value: password,
              onChange: (e) => setPassword(e.target.value),
              required: true,
              autoComplete: "current-password"
            }
          )
        }
      ),
      error && /* @__PURE__ */ jsx("div", { style: { color: "#db3737", marginBottom: "15px", fontSize: "0.9em" }, children: error }),
      /* @__PURE__ */ jsx(
        Button,
        {
          type: "submit",
          intent: Intent.PRIMARY,
          large: true,
          fill: true,
          loading,
          children: "Log In"
        }
      )
    ] })
  ] }) });
};
export default LoginPage;
